/* prettier-ignore */

import { CONNECTION_TIER_MAX_WIDTH, LOW_EFFECTIVE_TYPES, MEDIUM_EFFECTIVE_TYPES } from '../config/connection-tiers';
import { ConnectionTier, ImageVariantWidth, NetworkInformationLike } from '../interfaces';

/**
 * HRS-3471: the ONLY place in `src/` that touches `navigator.connection`.
 * The API only exists in Chromium engines (Chrome, Edge, Android WebView);
 * Safari, iOS/WKWebView and Firefox get `undefined` and therefore the `full` tier.
 * Read on demand (no `change` listeners): already-rendered images never swap.
 */
function getNavigatorConnection(): NetworkInformationLike | undefined {
  if (typeof navigator === 'undefined') return undefined;
  return (navigator as Navigator & { connection?: NetworkInformationLike }).connection;
}

/** Maps the connection hint to a tier. The parameter makes it verifiable with a stubbed object. */
export function readConnectionTier(connection: NetworkInformationLike | undefined = getNavigatorConnection()): ConnectionTier {
  if (!connection) return 'full';
  if (connection.saveData === true) return 'low';

  const effectiveType = connection.effectiveType ?? '';
  if (LOW_EFFECTIVE_TYPES.includes(effectiveType)) return 'low';
  if (MEDIUM_EFFECTIVE_TYPES.includes(effectiveType)) return 'medium';
  return 'full';
}

/** Maximum candidate width for the current connection, or `undefined` when no cap applies. */
export function readConnectionMaxWidth(connection: NetworkInformationLike | undefined = getNavigatorConnection()): ImageVariantWidth | undefined {
  return CONNECTION_TIER_MAX_WIDTH[readConnectionTier(connection)] ?? undefined;
}
